import * as React from "react";
import {useTranslation} from "react-i18next";
import { useState } from "react";
import { useModal } from "../../../../../../hooks/use_modal";
import { FileField } from "../../../../../Components/Form/FileField";
import { FormModal } from "../../../../../Components/FormModal";
import { Box, CircularProgress } from "@mui/material";
import { ICsvColumnMapping } from "../../../../../../helpers/bulk_helpers";
import { IBulkFormData } from "../../../../../../config/bulk";
import { ColumnMappingTable } from "./ColumnMappingTable";
import { bulkUploadMap } from "../../../../../../stores/bulk";

const FORMAT_LABELS = {
    'csv': 'CSV',
} as any;

interface IExpenses24FileUploadFieldProps {
    formats: string[];
    onChange(data?: IBulkFormData[] | null): void;
}

export const Expenses24FileUploadField = ({onChange, formats}: IExpenses24FileUploadFieldProps) => {
    const { t } = useTranslation();
    const { open, handleModalOpen, handleModalClose, loading, setLoading } = useModal();
    const [csvData, setCsvData] = useState<string[][] | null>(null);

    const handleChange = async (file?: File | null) => {
        if (!!file) {
            handleModalOpen();
            setLoading(true);

            try {
                const formData = new FormData();
                formData.append("format", 'csv');
                formData.append("source", 'global_es');
                formData.append("file", file, file!!.name);
        
                const mockCsvData = await bulkUploadMap(formData);

                setCsvData(mockCsvData as any);
                setLoading(false);
            } catch (error) {
                console.error('Error loading CSV data:', error);
                setLoading(false);
            }
        }
    };

    const handleMappingChange = (mapping: ICsvColumnMapping) => {
        // console.log('Mapping changed:', mapping);
    };

    const handleMappingConfirm = (mappedData: IBulkFormData[]) => {
        // Handle the mapped data - you can pass it to parent component or navigate to next step
        // console.log('Mapped data confirmed:', mappedData);
        
        // TODO: Pass mappedData to parent component or next step
        // Example: onChange(mappedData);

        handleModalClose();
        setCsvData(null);
        onChange(mappedData);
    };

    const handleFileDelete = () => {
        setCsvData(null);
        onChange(null);
    };

    const handleMappingCancel = () => {
        handleModalClose();
        setCsvData(null);
        onChange(null);
    };

    return (
        <>
            <FormModal open={open} onClose={handleMappingCancel} title="Map CSV Columns">
                <Box>
                    {loading && (
                        <Box sx={{display: 'flex', justifyContent: 'center', py: 4}}>
                            <CircularProgress size={80} color="primary" />
                        </Box>
                    )}
                    
                    {!loading && csvData && (
                        <ColumnMappingTable
                            csvData={csvData}
                            onMappingChange={handleMappingChange}
                            onConfirm={handleMappingConfirm}
                            onCancel={handleMappingCancel}
                        />
                    )}
                </Box>
            </FormModal>

            <FileField
                variant="button"
                onChange={handleChange}
                onDelete={handleFileDelete}
                label={t('transactions.bulk.upload_form.upload_button')}
                accept={formats.map(format => `.${format}`).join(', ')}
                helperText={t('transactions.bulk.upload_form.formats_supported', {formats: formats.map(f => FORMAT_LABELS[f]).join(', ')})!}
            />
        </>
    );
};
